import { render, staticRenderFns } from "./FbLikertOption.vue?vue&type=template&id=4f1572aa"
import script from "./FbLikertOption.vue?vue&type=script&lang=js"
export * from "./FbLikertOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports